import React from "react";
import {
    QuestionAnswer,
    InsertEmoticon,
    Quiz,
    Poll,
    TextFields,
    Cloud,
    Flaky,
    TouchApp,
    Photo, QuestionMark, Mic, FormatListNumbered, PanTool, Link, WbIncandescent, Rtt,
    PhotoAlbum
} from "@mui/icons-material";

import {THEME_CONFIG} from "../../config";
import { useTranslation } from 'react-i18next';

const {homeQuestionIcon} = THEME_CONFIG

const hasIcon = (icon) => homeQuestionIcon ? icon : null

// Hook per ottenere i tipi di domande con traduzioni
export const useQuestionType = () => {
    const { t } = useTranslation('questions');
    
    return {
        qna: {
            text: t('types.qa'),
            icon: hasIcon(<QuestionAnswer/>)
        },
        toolpress: {
            text: t('types.toolpress'),
            icon: hasIcon(<QuestionAnswer/>)
        },
        quiz: {
            text: t('types.quiz'),
            icon: hasIcon(<Quiz/>)
        },
        poll: {
            text: t('types.poll'),
            icon: hasIcon(<Poll/>)
        },
        imagePoll: {
            text: t('types.imagePoll'),
            icon: hasIcon(<Poll/>)
        },
        colorPoll: {
            text: t('types.colorPoll'),
            icon: <WbIncandescent/>
        },
        reorder: {
            text: t('types.reorder'),
            icon: hasIcon(<FormatListNumbered/>)
        },
        wordcloud: {
            text: t('types.wordcloud'),
            icon: hasIcon(<Cloud/>)
        },
        sentiment: {
            text: t('types.sentiment'),
            icon: hasIcon(<InsertEmoticon/>)
        },
        siNo: {
            text: t('types.siNo'),
            icon: hasIcon(<Flaky/>)
        },
        clickTo:{
            text: t('types.clickTo'),
            icon: hasIcon(<TouchApp/>)
        },
        links:{
            text: t('types.clickTo'),
            icon: hasIcon(<Link/>)
        },
        text: {
            text: t('types.text'),
            icon: hasIcon(<Rtt/>)
        },
        color:{
            text: t('types.colorSmartphone'),
            icon: hasIcon(<WbIncandescent />)
        },
        sendPhoto:{
            text: t('types.sendPhoto'),
            icon: hasIcon(<Photo/>)
        },
        audio:{
            text: t('types.sendAudio'),
            icon: hasIcon(<Mic/>)
        },
        reserveSpot: {
            text: t('types.reserveSpot'),
            icon: hasIcon(<PanTool/>)
        },
        photoGallery: {
            text: t('types.photoGallery'),
            icon: hasIcon(<PhotoAlbum/>)
        },
        altro:{
            text: t('types.other'),
            icon: hasIcon(<QuestionMark/>)
        },
    };
};

// Export di default per compatibilità - contiene solo le icone (il testo viene dai dati)
const questionTypeIcons = {
    qna: {
        icon: hasIcon(<QuestionAnswer/>)
    },
    toolpress: {
        icon: hasIcon(<QuestionAnswer/>)
    },
    quiz: {
        icon: hasIcon(<Quiz/>)
    },
    poll: {
        icon: hasIcon(<Poll/>)
    },
    imagePoll: {
        icon: hasIcon(<Poll/>)
    },
    colorPoll: {
        icon: <WbIncandescent/>
    },
    reorder: {
        icon: hasIcon(<FormatListNumbered/>)
    },
    wordcloud: {
        icon: hasIcon(<Cloud/>)
    },
    sentiment: {
        icon: hasIcon(<InsertEmoticon/>)
    },
    siNo: {
        icon: hasIcon(<Flaky/>)
    },
    clickTo:{
        icon: hasIcon(<TouchApp/>)
    },
    links:{
        icon: hasIcon(<Link/>)
    },
    text: {
        icon: hasIcon(<Rtt/>)
    },
    color:{
        icon: hasIcon(<WbIncandescent />)
    },
    sendPhoto:{
        icon: hasIcon(<Photo/>)
    },
    audio:{
        icon: hasIcon(<Mic/>)
    },
    reserveSpot: {
        icon: hasIcon(<PanTool/>)
    },
    photoGallery: {
        icon: hasIcon(<PhotoAlbum/>)
    },
    altro:{
        icon: hasIcon(<QuestionMark/>)
    },
}

// Per compatibilità con codice esistente che usa questionType[tipo]?.icon
const questionType = questionTypeIcons;

export default questionType
